import React from 'react';
import Button from '@mui/material/Button';
import { useRouter } from 'next/router';

function Unauthorized() {
  let router = useRouter();

  return (
    <div style={{ height: 400 }}>
      <h1 style={{ fontSize: 80 }}>401</h1>
      <h1 style={{ fontSize: 30 }}>Unauthorized</h1>
      <div style={{ marginTop: 50 }}>
        <p style={{ fontSize: 16, margin: 10 }}>You do not have the proper credentials to view this page.</p>
        <p style={{ fontSize: 16, margin: 10 }}>Check to make sure you are logged in and have permission to proceed.</p>
        <Button
          variant="contained"
          color="primary"
          onClick={() => router.back()}
          style={{ margin: 10 }}
        >Go Back
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;